import { FormattedMessage, useIntl } from 'react-intl';
import Modal from '@/shared/components/Modal';
import ErrorAlert from '@/shared/components/ErrorAlert';
import ModalButton from '@/shared/components/ModalButton';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting: boolean;
  error: string | null;
}

export default function RemoveAccountModal({ isOpen, onClose, onConfirm, isSubmitting, error }: Props) {
  const intl = useIntl();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={intl.formatMessage({ id: 'accounts.card.removeTitle' })}
      eyebrow={intl.formatMessage({ id: 'accounts.card.removeEyebrow' })}
      footer={
        <>
          <ModalButton type="button" onClick={onClose} disabled={isSubmitting} variant="secondary">
            <FormattedMessage id="accounts.card.removeCancel" />
          </ModalButton>
          <ModalButton type="button" onClick={onConfirm} disabled={isSubmitting} variant="danger">
            {isSubmitting ? (
              <FormattedMessage id="accounts.card.removing" />
            ) : (
              <FormattedMessage id="accounts.card.removeConfirm" />
            )}
          </ModalButton>
        </>
      }
    >
      <div className="space-y-5">
        <p className="text-sm text-slate-600">
          <FormattedMessage id="accounts.card.removeBody" />
        </p>
        {error && <ErrorAlert message={error} />}
      </div>
    </Modal>
  );
}
